import { render, staticRenderFns } from "./echarts-common.vue?vue&type=template&id=38a592e8&scoped=true"
import script from "./echarts-common.vue?vue&type=script&lang=js"
export * from "./echarts-common.vue?vue&type=script&lang=js"
import style0 from "./echarts-common.vue?vue&type=style&index=0&id=38a592e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a592e8",
  null
  
)

export default component.exports